module.exports = __webpack_public_path__ + "img/leaving-page-illustration.8cf99b0d.svg";